import { render, staticRenderFns } from "./TenantManager.vue?vue&type=template&id=2c7678ea&scoped=true&"
import script from "./TenantManager.vue?vue&type=script&lang=js&"
export * from "./TenantManager.vue?vue&type=script&lang=js&"
import style0 from "./TenantManager.vue?vue&type=style&index=0&id=2c7678ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7678ea",
  null
  
)

export default component.exports